import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import Oval from '../../../components/oval/oval'
import Rectangle from '../../../components/text/rectangle'
import Icon from '../../../components/icon/icon'

import oval2copy2 from '../../../static/images/oval/oval-2-copy-2.png'
import oval2copy from '../../../static/images/oval/oval-2-copy.png'
import oval2 from '../../../static/images/oval/oval-2.png'

const InnovationContainer = styled.div`
  background-color: white;
  padding-top: 50px;
  margin-bottom: 50px;
  ${media.md`
    margin-bottom: 0;
  `};
`
const InnovationWrapper = styled.div`
  z-index: 2;
  position: relative;
`

const Title = styled.h3`
  margin: 0 0 20px;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #3c4252;
  ${media.md`
    font-size: 25px;
  `};
`

const Intro = styled.p`
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 15px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #3c4252;
  ${media.md`
    font-size: 18px;
  `};
`

const StyledDecorationRight = styled(Icon)`
  fill: #824f59;
  position: absolute;
  top: 20%;
  right: 0;
  z-index: 1;
  width: 278px;
  height: 363px;
`

const StyledDecorationLeft = styled(Icon)`
  fill: #40b4e4;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 292px;
  height: 300px;
`

const Innovation = props => {
  return (
    <InnovationContainer {...props}>
      <Title>Nuestro proceso de innovación</Title>
      <Intro>
        La innovación empieza desde las personas, todos los involucrados en el
        negocio
      </Intro>
      <div className="container">
        <InnovationWrapper className="row align-items-center">
          <div className="col-md-6 text-center">
            <Oval img={oval2} />
          </div>
          <div className="col-md-6">
            <Rectangle
              title="Modelo de negocio"
              text="Empezamos entendiendo el giro de negocio de nuestros clientes y el descubrimiento de los medios y métodos óptimos para la transformación digital de sus empresas, encontrando su oportunidad de mercado en digital."
            />
          </div>
        </InnovationWrapper>
        <InnovationWrapper className="row align-items-center">
          <div className="col-md-6 text-center order-md-12">
            <Oval img={oval2copy} />
          </div>
          <div className="col-md-6 text-center order-md-2">
            <Rectangle
              title="Tecnología"
              text="Una vez encontrada la mejor manera de su transformación digital nos apoyamos en herramientas de tecnología que nos ayudan a guiar los procesos y analizar la información."
            />
          </div>
        </InnovationWrapper>
        <InnovationWrapper className="row align-items-center">
          <div className="col-md-6 text-center">
            <Oval img={oval2copy2} />
          </div>
          <div className="col-md-6 text-center">
            <Rectangle
              title="Experiencia del consumidor"
              text="Dando como resultado una adecuada experiencia del consumidor, que desemboca en ventas digitales y procesos simplificados."
            />
          </div>
        </InnovationWrapper>
        <StyledDecorationRight
          className="d-none d-md-block"
          name="decoration-right"
        />
        <StyledDecorationLeft
          className="d-none d-md-block"
          name="decoration-left"
        />
      </div>
    </InnovationContainer>
  )
}

export default Innovation



// WEBPACK FOOTER //
// ./src/components/section/innovation/innovation.js